import Swiper from 'swiper/bundle'

export default class Slides {
    constructor(el) {
        // Check view element
        if (el instanceof HTMLElement) {
            this.el = el
        } else {
            this.el = document.querySelector(el)
        }
        if (!this.el) {
            console.warn('No valid slides found. Sorry bro.')
            return false
        }

        // Init swiper
        this.swiper = new Swiper(el, {
            allowTouchMove: false,
            virtualTranslate: true
        })

        // Switch slide classes to animate
        this.swiper.on('slideChange', this.slideChange.bind(this))
    }

    slideChange() {
        // Remove old previous class
        if(this.el.querySelector('.swiper-slide-previous'))
            this.el.querySelector('.swiper-slide-previous').classList.remove('swiper-slide-previous')
        // Add new previous class
        this.swiper.slides[this.swiper.previousIndex].classList.add('swiper-slide-previous')
    }

    slideTo(index) {
        this.swiper.slideTo(index)
    }
}